
import backofficeService from '../../api/backoffice'

export default {

  /**
   * Get All Settings
   * @param {*} params Query Options
   */
  getAll(params) {
    return backofficeService.Api().get('organization', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get All Settings
   * @param {*} params Query Options
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`organization/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get All Settings
   * @param {*} params Query Options
   */
  getCurrent(id, params = {}) {
    return backofficeService.Api().get('organization/current', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * New Organization
   * @param {*} params Query Options
   */
  create(data) {
    return backofficeService.Api().post('organization', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * update Organization
   * @param {*} params Query Options
   */
  update(id, data) {
    return backofficeService.Api().put(`organization/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   *  Get token from server
   * @param {} id
   * @param {*} pin
   * @param {*} locationCode
   * @param {*} deviceCode
   * @param {*} deviceName
   */
  authenticate(params) {
    return backofficeService.Api().post('auth/token', {
      email: params.email,
      password: params.password,
    })
      .then((response) => {
        // localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`, response.data.data.token)
        return response.data
      })
      .catch((error) => { throw error })
  },
  /**
   * Remove the location code store if there exist one/
   */
  resetOrganization() {
    return localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`)
  },
  /**
   * Send forgot password email
   * @param {*} params Query Options
   */
  forgetPassword(data) {
    return backofficeService.Api().post('auth/forget', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  orderHardware(data) {
    return backofficeService.Api().post('location/orderHardware', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Reset Password
   * @param {*} params Query Options
   */
  resetPassword(data) {
    return backofficeService.Api().post('auth/reset', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getCurrent(params) {
    console.log('params', params)
    return backofficeService.Api().get('organization/current', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getCurrentUser(params) {
    console.log('params', params)
    return backofficeService.Api().get('user/current', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  Billing: {
    /**
     * Get All Settings
     * @param {*} params Query Options
     */
    getCustomer(params) {
      return backofficeService.Api().get('billing/customer', { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    /**
     * Get all cards on file
     * @param {*} params Query Options
     */
    getCards(params) {
      return backofficeService.Api().get('billing/cards', { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    /**
     * Make a card default
     * @param {*} params Query Options
     */
    setDefaultCard(data) {
      return backofficeService.Api().put('billing/defaultSource', data)
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    /**
     * Make a card default
     * @param {*} params Query Options
     */
    addCard(data) {
      return backofficeService.Api().post('billing/cards', data)
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    /**
     * Delete Card
     * @param {*} params Query Options
     */
    deleteCard(params) {
      return backofficeService.Api().delete('billing/cards', {params})
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    /**
     * Delete Card
     * @param {*} params Query Options
     */
    getCardById(id) {
      return backofficeService.Api().get(`billing/card/${id}`)
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    locationCardById(data) {
      return backofficeService.Api().post(`billing/cardById`, data)
        .then(response => response.data)
        .catch((error) => { throw error })
    },
  },
}
